<template>
  <div class="wrapper-content w-100">
    <h4>Datos del iniciador</h4>
    <LmForm ref="lmFormRef" v-slot:default="slotProps">
      <div class="row">
        <LmSelect
          class="col-12 col-lg-6"
          v-model="form.tipoIniciador"
          :v="$v.form.tipoIniciador"
          :options="tiposIniciadores"
          label="Tipo Iniciador"
          :disabled="slotProps.isOnEditMode"
          />
      </div>
      <component
        :is="tipoIniciador"
        :validation="$v.form"
        :form="form"
        :isOnEditMode="slotProps.isOnEditMode"
        />
      <hr>
      <h4>Domicilio del trámite</h4>
      <div class="row">
        <LmSuperPowerSelect
          class="col-12 col-lg-6"
          v-if="!slotProps.isOnEditMode"
          :data="lmSuperPowerSelects.calleTramite.selectOptions"
          :tbColumns="lmSuperPowerSelects.calleTramite.tbColumns"
          label="Calle Trámite"
          :v="$v.form.calleTramite"
          :model="form.calleTramite"
          @values="updateCalleAltura"
          :disabled="slotProps.isOnEditMode"
        />
        <LmTextInput v-else
          class="col-12 col-lg-6"
          v-model="form.calleTramite"
          :v="$v.form.calleTramite"
          label="Calle"
          placeholder="Calle"
          :disabled="slotProps.isOnEditMode"
          />
        <LmNumberInput
          class="col-12 col-lg-6"
          v-model="form.alturaTramite"
          :v="$v.form.alturaTramite"
          label="Altura"
          placeholder="Altura"
          :disabled="slotProps.isOnEditMode"
          />
      </div>
      <div class="row">
        <LmTextInput
          class="col-12 col-lg-6"
          v-model="form.pisoTramite"
          :v="$v.form.pisoTramite"
          label="Piso"
          placeholder="Piso"
          :disabled="slotProps.isOnEditMode"
          />
        <LmTextInput
          class="col-12 col-lg-6"
          v-model="form.departamentoTramite"
          :v="$v.form.departamentoTramite"
          label="Departamento"
          placeholder="Departamento"
          :disabled="slotProps.isOnEditMode"
          />
      </div>
      <div class="row">
        <div v-if="form.calleTramiteLocation" class="col-12">
          <LmLeaFletMap
            :markerLatLng="markerTramiteLatLng"
            :centerMapCoordinate="markerTramiteLatLng"
            class="mb-3"
            />
        </div>
      </div>
      <hr>
      <h4>Trámite a Realizar</h4>
      <div class="row">
        <LmSuperPowerSelect
          class="col-12 col-lg-6"
          :data="lmSuperPowerSelects.tipoTramite.selectOptions"
          :tbColumns="lmSuperPowerSelects.tipoTramite.tbColumns"
          label="Tipo"
          :v="$v.form.tipoTramite"
          @values="updateTipoTramite"
          :model="form.tipoTramite"
          :disabled="slotProps.isOnEditMode"
        />
      </div>
      <div class="row">
        <LmSuperPowerSelect
          class="col-12 col-lg-6"
          :data="lmSuperPowerSelects.tiposDocumentos.selectOptions"
          :tbColumns="lmSuperPowerSelects.tiposDocumentos.tbColumns"
          label="Clasificación"
          :v="$v.form.clasificacion"
          @values="updateClasificacion"
          :model="sanitizeModel(form.idClasificacion)"
          :disabled="slotProps.isOnEditMode"
        />
      </div>
      <div class="row">
        <LmSuperPowerSelect
          class="col-12 col-lg-6"
          :data="lmSuperPowerSelects.subclasificaciones.selectOptions"
          :tbColumns="lmSuperPowerSelects.subclasificaciones.tbColumns"
          label="Subclasificación"
          @values="updateSubclasificaciones"
          :model="sanitizeModel(subclasificacionesPreLoad)"
          :disabled="slotProps.isOnEditMode"
        />
      </div>
      <hr />
      <div class="row">
        <LmTextArea
          class="col-12 col-lg-6"
          v-model="form.observaciones"
          :v="$v.form.observaciones"
          label="Observaciones"
          placeholder="Observaciones del trámite"
          :disabled="slotProps.isOnEditMode"
          />
      </div>
      <LmButton type="button" value="Submit" @click.native="submit()"/>
    </LmForm>
  </div>
</template>

<script>
import LmForm from '@/components/form/LmForm.vue'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmSelect from '@/components/form/elements/LmSelect'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmDate from '@/components/form/elements/LmDate'
import LmButton from '@/components/form/elements/LmButton'
import formValidation from '@/views/mvlmesa/expedientes/refactoredExpedientesNewOrEditValidation'
import LmLeaFletMap from '@/components/LmLeaFletMap.vue'
import Persona from '@/views/mvlmesa/expedientes/refactoredExpedientesNewOrEdit_sub_components/Persona.vue'
import AreaInterna from '@/views/mvlmesa/expedientes/refactoredExpedientesNewOrEdit_sub_components/AreaInterna.vue'
import PersonaJuridica from '@/views/mvlmesa/expedientes/refactoredExpedientesNewOrEdit_sub_components/PersonaJuridica.vue'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
export default {
  mixins: [lmSuperPowerSelectHelper],
  components: {
    LmForm,
    LmSuperPowerSelect,
    LmTextInput,
    LmNumberInput,
    LmEmailInput,
    LmButton,
    LmTextArea,
    LmSelect,
    LmDateTime,
    LmDate,
    LmLeaFletMap,
    Persona,
    AreaInterna,
    PersonaJuridica
  },
  data () {
    return {
      tiposIniciadores: {
        disabledOption: 'Seleccione el Tipo de Iniciador',
        content: ['Persona', 'Persona Jurídica', 'Area Interna']
      },
      lmSuperPowerSelects: {
        calleTramite: {
          selectOptions: [],
          tbColumns: [
            { title: 'Calle', data: 'name' }
          ]
        },
        tipoTramite: {
          selectOptions: [],
          tbColumns: [
            { title: 'id', data: 'id' },
            { title: 'Tipo', data: 'name' }
          ]
        },
        tiposDocumentos: {
          selectOptions: [],
          tbColumns: [
            { title: 'id', data: 'id' },
            { title: 'Tipo', data: 'name' }
          ]
        },
        subclasificaciones: {
          selectOptions: [],
          tbColumns: [
            { title: 'id', data: 'id' },
            { title: 'Subclasificación', data: 'name' }
          ]
        }
      },
      form: {
        tipoIniciador: 'Persona',
        calleTramite: '',
        tipoTramite: '',
        clasificacion: '',
        idClasificacion: '',
        observaciones: '',
        alturaTramite: '',
        pisoTramite: '',
        departamentoTramite: '',
        idCalleTramite: '',
        calleTramiteAlturaDesde: '',
        calleTramiteAlturaHasta: '',
        calleTramiteNombre: '',
        calleTramiteLocalidad: '',
        calleTramiteLocation: [],
        tipoTramiteDetalle: '',
        idOficinaAreaInterna: '',
        oficinaAreaInterna: '',
        tipoDocumento: '',
        idTipoDocumento: '',
        numero: '',
        apellido: '',
        emailIniciador: '',
        direccionIniciador: {
          latLong: [],
          formattedAddress: ''
        },
        tipoSociedad: 'SA',
        razonSocial: '',
        cuit: '',
        domiciolioComercio: '',
        emailComercio: ''
      }
    }
  },
  computed: {
    tipoIniciador () {
      let tipoIniciado
      console.log('this.form.tipoIniciado', this.form.tipoIniciador)
      switch (this.form.tipoIniciador) {
        case 'Persona Jurídica':
          tipoIniciado = 'PersonaJuridica'
          break

        case 'Area Interna':
          tipoIniciado = 'AreaInterna'
          break

        default:
          tipoIniciado = 'Persona'
          break
      }
      console.log('tipoIniciador after switch', tipoIniciado)
      return tipoIniciado
    },
    subclasificacionesPreLoad () {
      return this.form.subclasificaciones ? this.form.subclasificaciones.map((e) => e.id) : ''
    },
    markerTramiteLatLng: {
      get () {
        return this.form.calleTramiteLocation ? this.form.calleTramiteLocation : []
      },
      set () {}
    }
  },
  validations: {
    form: formValidation
  },
  methods: {
    submit () {
      this.$refs.lmFormRef.validationForm(this.$v)
        .then(r => {
          console.log('r', r)
        })
    },
    sanitizeModel (model) {
      return model ? model.toString() : ''
    },
    updateCalleAltura  (values) {
      let value = values[0]
      if (value.length) {
        this.form.idCalleTramite = value.id ? value.id : ''
        this.form.calleTramite = value.name ? value.name : ''
        this.form.calleTramiteAlturaDesde = value.desde ? value.desde : ''
        this.form.calleTramiteAlturaHasta = value.hasta ? value.hasta : ''
        this.form.calleTramiteNombre = value.calle ? value.calle : ''
        this.form.calleTramiteLocalidad = value.localidad ? value.localidad : ''
      }
    },
    updateSubclasificaciones (data) {
      this.form.subclasificaciones = data.map(e => {
        return { id: e.id, name: e.name }
      })
    },
    updateTipoTramite (value) {
      // Si escribimos la validación de esta forma evitarmos repetir los properties data para el reset minimizamos código y evitamos algunos potenciales
      const areValue = value.length
      this.form.tipoTramite = areValue ? value[0].id : ''
      this.form.tipoTramiteDetalle = areValue ? value[0].name : ''
    },
    updateClasificacion (value) {
      if (value.length) {
        this.form.idClasificacion = value[0].id
        this.form.clasificacion = value[0].name
        this.getAllLmSuperPowerSelectOptions(
          [
            { name: 'subclasificaciones',
              obj: {
                path: 'subclasificaciones/predictivo/',
                parentId: this.form.idClasificacion,
                total: 500
              }
            }
          ]
        ).then(response => {
          response.forEach(async element => {
            const e = await element
            this.lmSuperPowerSelects[e.name].selectOptions = e.data
          })
        })
      } else {
        this.lmSuperPowerSelects.subclasificaciones.selectOptions = []
      }
    }
  },
  mounted () {
    if (this.$route.query.mode === 'edit') {
      this.$refs.lmFormRef.activeEditMode({
        path: 'expedientes/activos/edit/',
        id: '821268'
      })
    }
    this.getAllLmSuperPowerSelectOptions(
      [
        { name: 'calleTramite', obj: { path: 'callesalturas/todos/', total: 1000 } },
        { name: 'tipoTramite', obj: { path: 'codificaciones/tipos_documentos/', total: 1000 } },
        { name: 'tiposDocumentos', obj: { path: 'clasificaciones/predictivo/', total: 500 } }
      ]
    ).then(response => {
      response.forEach(async element => {
        const e = await element
        this.lmSuperPowerSelects[e.name].selectOptions = e.data
      })
    })
  }
}
</script>

<style lang="sass" scoped>
  hr
    border-top: 2px solid !important
    margin-top: 50px !important
    margin-bottom: 20px !important
</style>
